<!--
 * @Author: your name
 * @Date: 2021-03-08 13:36:11
 * @LastEditTime: 2021-04-20 09:19:45
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: /youhuaguo-ui/src/views/business/contract/show.vue
-->
<template>
  <div class="list-panel">
    <div class="main-container">
      <div class="tab-con">
        <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
          <el-menu-item index="show">查看商务合同</el-menu-item>
          <el-menu-item index="allAttachment">合同附件列表</el-menu-item>
          <el-menu-item index="blogList">合作博主列表</el-menu-item>
          <el-menu-item index="invoice">开票记录</el-menu-item>
		  <el-menu-item index="backMoney">回款记录</el-menu-item>
        </el-menu>
      </div>
      <div class="content-wrap">
        <contract-form v-if="activeIndex == 'show'" operate-type="show"></contract-form>
        <blogger-list v-else-if="activeIndex == 'blogList'" link-to="delivery"></blogger-list>
        <lnvoice-list v-else-if="activeIndex == 'invoice'" operate-type="show"></lnvoice-list>
        <back-money v-else-if="activeIndex == 'backMoney'" operate-type="edit"></back-money>
        <allAttachment v-else-if="activeIndex == 'allAttachment'" operateType="edit"></allAttachment>
      </div>
    </div>
  </div>
</template>

<script>
import ContractForm from "./component/form";
import BloggerList from "./media/list";
import LnvoiceList from "./invoice/invoice-one";
import BackMoney from "./backMoney/list.vue";
import allAttachment from "./attachment/allattachment";
export default {
  components: {
    ContractForm,
    BloggerList,
    LnvoiceList,
	  BackMoney,
    allAttachment
  },
  data() {
    return {
      activeIndex: "show",
    };
  },
  methods: {
    handleSelect(key, keyPath) {
      this.activeIndex = key;
    },
  },
};
</script>